var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockFullCloseLtr = function SvgLockFullCloseLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M36.394 26.313c0-7.504 6.02-13.608 13.42-13.608s13.42 6.104 13.42 13.608v13.213h-26.84zm41.125 13.213h-7.672V26.313C69.847 15.113 60.86 6 49.814 6s-20.032 9.112-20.032 20.313v13.213H21.48c-4.124 0-7.48 3.402-7.48 7.584v39.305C14 90.597 17.356 94 21.48 94h56.04c4.124 0 7.48-3.403 7.48-7.585V47.11c0-4.182-3.356-7.584-7.48-7.584",
    clipRule: "evenodd"
  })));
};
export default SvgLockFullCloseLtr;